<template>
  <v-container>
    <v-card>
      <v-card-title
        ><v-row
          ><v-col :cols="$vuetify.breakpoint.width < 455 ? 12 : 6" sm="6">
            {{ periodoActual ? "Periodo actual" : "Próximo periodo" }} </v-col
          ><v-col
            :cols="$vuetify.breakpoint.width < 455 ? 12 : 6"
            sm="6"
            class="text-right"
          >
            <v-btn color="primary" @click="nuevoItem">
              <div v-if="periodoActual">
                <v-icon>mdi-arrow-right-bold</v-icon> Próximo periodo
              </div>
              <div v-else>
                Periodo actual <v-icon>mdi-arrow-left-bold</v-icon>
              </div></v-btn
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle
        ><v-row
          ><v-col
            cols="12"
            sm="5"
            md="4"
            :class="{
              'text-lg': $vuetify.breakpoint.xs || $vuetify.breakpoint.mdAndUp,
              'text-md': $vuetify.breakpoint.sm,
            }"
          >
            Ciclo <strong>{{ item.ciclo }}</strong></v-col
          ><v-col
            cols="12"
            sm="7"
            md="8"
            :class="{
              'text-lg': $vuetify.breakpoint.xs || $vuetify.breakpoint.mdAndUp,
              'text-md': $vuetify.breakpoint.sm,
            }"
          >
            Semestre
            <strong>{{
              item.semestre == 1 ? "IMPAR (AGO-DIC)" : "PAR (FEB-JUL)"
            }}</strong></v-col
          >
        </v-row></v-card-subtitle
      >
    </v-card>

    <v-divider />

    <v-card>
      <v-card-text
        class="secondary"
        :class="{
          'lighten-2': !$vuetify.theme.dark,
          'darken-2': $vuetify.theme.dark,
        }"
      >
        <v-row>
          <v-col cols="6"
            ><p class="mb-0 text-md font-weight-bold">Grupos</p></v-col
          >
          <v-col
            ><p class="text-right mb-0">
              <v-btn
                color="secondary"
                :class="{
                  'black--text': !$vuetify.theme.dark,
                  'white--text': $vuetify.theme.dark,
                }"
                @click.stop="nuevoGrupo"
                >Añadir</v-btn
              >
            </p></v-col
          >
        </v-row>
        <p class="mt-0 mb-0" v-if="!grupos">
          No tiene grupos asignados para el semestre.
        </p>
        <v-row no-gutters v-else>
          <v-col
            cols="1"
            v-for="grupo in grupos"
            :key="grupo.id"
            :class="{
              custom7cols: $vuetify.breakpoint.sm || $vuetify.breakpoint.md,
              custom4cols: $vuetify.breakpoint.xs,
            }"
            class="py-0"
          >
            <p class="text-center my-0">
              {{ grupo.semestre + grupo.letra + "-" + grupo.turno }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <p class="mb-0"><strong>PENDIENTES</strong></p>
        <ul>
          <li>
            Botón para crear copia de trabajo (version-2) en carga académica,
            tutorías y horarios.
          </li>
          <li>Horarios</li>
          <li>Complementarias</li>
        </ul>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-btn
                :elevation="hover ? 12 : 0"
                :class="{ 'on-hover': hover }"
                block
                height="100px"
                class="secondary btn-opciones"
                :to="
                  '/carga-academica/' +
                  (periodoActual ? 'periodo-actual' : 'proximo-periodo')
                "
                >Carga Académica</v-btn
              >
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-btn
                :elevation="hover ? 12 : 0"
                :class="{ 'on-hover': hover }"
                block
                height="100px"
                class="secondary btn-opciones"
                :to="
                  '/tutorias/' +
                  (periodoActual ? 'periodo-actual' : 'proximo-periodo')
                "
                >Tutorías</v-btn
              >
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-btn
                :elevation="hover ? 12 : 0"
                :class="{ 'on-hover': hover }"
                block
                height="100px"
                class="secondary btn-opciones"
                :to="
                  '/respalda/' +
                  (periodoActual ? 'periodo-actual' : 'proximo-periodo')
                "
                >Respalda Cargas y Tutorías</v-btn
              >
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-btn
                :elevation="hover ? 12 : 0"
                :class="{ 'on-hover': hover }"
                block
                height="100px"
                class="secondary btn-opciones"
                :to="
                  '/restablece/' +
                  (periodoActual ? 'periodo-actual' : 'proximo-periodo')
                "
                >Restablece Cargas y<br />Tutorías</v-btn
              >
            </v-hover>
          </v-col>
          <v-col cols="12" v-if="!periodoActual">
            <p>
              <v-btn block class="primary" @click.stop="confirmaCambio = true"
                >Establecer este periodo como el ACTUAL</v-btn
              >
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row justify="center">
      <v-dialog v-model="confirmaCambio" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            Confirma cambio de Periodo
          </v-card-title>
          <v-card-text
            ><p>
              Por favor confirma que deseas que este periodo se establezca como
              el Periodo Actual, es decir, realizar un cambio al siguiente
              semestre.
            </p>
            <p>
              Ten en consideración que este proceso no se puede deshacer.
            </p></v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmaCambio = false"> Cancelar </v-btn>
            <v-btn color="red darken-1" text @click="cambiaSemestre">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <loading-wait :loading="loading" />

    <Periodo
      :open="showItem"
      :datos="nextItem"
      @save="actualiza('insert')"
      @exit="oculta"
    />

    <GrupoDialog
      v-if="showGrupo"
      :open="showGrupo"
      :datos="grupo"
      :grupos="grupos"
      :semPar="item.semestre == 2"
      @save="actualizaGrupo('insert')"
      @exit="ocultaGrupo"
    />
  </v-container>
</template>

<script>
import api from "@/api";
import Periodo from "@/components/Periodo";
import GrupoDialog from "@/components/GrupoDialog";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";

export default {
  name: "Periodos",

  components: { Periodo, GrupoDialog, LoadingWait },

  mixins: [gets],

  data: () => ({
    periodoActual: true,
    item: {},
    nextItem: {},
    grupo: {},
    grupos: null,
    showGrupo: false,
    showItem: false,
    newItem: true,
    confirmaCambio: false,
    loading: false,
  }),

  methods: {
    async actualiza(action) {
      let data = {
        table: "periodos",
        scope: "ind",
        data: this.nextItem,
      };
      if (this.newItem) {
        data = {
          ...data,
          action: "insert",
        };
      } else {
        data = {
          ...data,
          action: action,
        };
      }
      if (this.newItem || this.item.id + "." != ".") {
        try {
          const response = await api.send(data);
          if (action == "delete" || this.newItem) this.nuevoItem();
        } catch (error) {
          console.log(error);
        }
      }
    },

    async actualizaGrupo(action) {
      this.loading = true;
      let data = {
        table: "grupos",
        action: action,
        scope: "ind",
        data: this.grupo,
      };
      try {
        const response = await api.send(data);
        this.grupos = await this.getGrupos(this.item.id);
        // this.grupo.letra = String.fromCharCode(
        //   this.grupo.letra.charCodeAt(0) + 1
        // );
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      // this.showGrupo = false;
    },

    async cambiaSemestre() {
      let nextId = this.item.id;
      this.newItem = false;

      // Periodo actual en desuso
      await this.getItems(true);
      this.nextItem = {
        id: this.item.id,
        actual: 0,
      };
      await this.actualiza("patch");
      // Próximo periodo como actual
      this.nextItem = {
        id: nextId,
        actual: 1,
        proximo: 0,
      };
      await this.actualiza("patch");
      this.nuevoItem();

      this.newItem = true;
      this.confirmaCambio = false;
    },

    async getItems(scope) {
      const response = await api.send({
        table: "periodos",
        action: "get",
        scope: scope ? "actual" : "proximo",
      });
      if (response && response.status == 200) {
        if (response.data) this.item = response.data;
        this.showItem = false;
        return response.data;
      } else return null;
    },

    nuevoGrupo() {
      this.grupo = {
        periodo_id: this.item.id,
        carrera_id: 2,
        semestre: this.item.semestre,
        letra: "A",
        turno: "TV",
      };
      this.showGrupo = true;
    },

    async nuevoItem() {
      let response = await this.getItems(!this.periodoActual);
      if (response) {
        this.periodoActual = !this.periodoActual;
        this.grupos = await this.getGrupos(this.item.id);
      } else {
        this.nextItem = {
          id: "",
          ciclo:
            this.item.semestre == 1
              ? this.item.ciclo
              : this.item.ciclo.substr(5, 4) +
                "-" +
                (parseInt(this.item.ciclo.substr(5, 4)) + 1),
          semestre: this.item.semestre == 1 ? "2" : "1",
          actual: "0",
          proximo: "1",
        };
        this.showItem = true;
      }
    },

    oculta() {
      this.getItems(this.periodoActual);
      this.showItem = false;
    },

    async ocultaGrupo() {
      // await this.getItems(this.periodoActual);
      this.grupos = await this.getGrupos(this.item.id);
      this.showGrupo = false;
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Periodos");
    this.periodoActual = true;
    await this.getItems(this.periodoActual);
    this.grupos = await this.getGrupos(this.item.id);
    // this.nuevoItem();
  },
};
</script>

<style>
.custom4cols {
  width: 25%;
  max-width: 25%;
  flex-basis: 25%;
}
.custom7cols {
  width: 14%;
  max-width: 14%;
  flex-basis: 14%;
}
.custom8cols {
  width: 12.5%;
  max-width: 12.5%;
  flex-basis: 12.5%;
}
.btn-opciones {
  transition: opacity 0.4s ease-in-out;
}
.btn-opciones:not(.on-hover) {
  opacity: 0.6;
}
</style>